import { SessionLifecycleController } from '@adapters/controllers/SessionLifecycleController';
import type { SessionExpiredRecovery } from '@core/ports/SessionExpiredRecovery';
import { JourneyDraftStore } from '@infrastructure/storage/JourneyDraftStore';

export interface SessionExpiredPageViewModel {
  title: string;
  message: string;
}

export class SessionExpiredController {
  public constructor(
    private readonly sessionLifecycleController: SessionLifecycleController,
    private readonly sessionExpiredRecovery: SessionExpiredRecovery,
    private readonly journeyDraftStore: JourneyDraftStore
  ) {}

  public async enterPage(): Promise<SessionExpiredPageViewModel> {
    this.journeyDraftStore.clear();
    const snapshot = this.sessionLifecycleController.getSnapshot();
    void this.sessionExpiredRecovery.returnOrFallback();

    return {
      title: snapshot.title ?? 'Session expired',
      message: snapshot.message ?? 'Your session has ended due to inactivity.'
    };
  }

  public async returnToNhsApp(): Promise<void> {
    await this.sessionExpiredRecovery.returnOrFallback();
  }
}